export interface ScreenInfo {
	width: number;
	height: number;
	'scaling-factor': number;
	'colour-depth': number;
}

export interface DeviceInfo {
	'Gov-Client-Browser-JS-User-Agent': string;
	'Gov-Client-Screens': string;
	'Gov-Client-Timezone': string;
	'Gov-Client-Window-Size': string;
}

/**
 * get User-Agent
 * @returns {string} User-Agent string
 */
export const getUserAgent = (): string => {
	return navigator.userAgent;
};

/**
 * Get information about screens
 * @returns {string} String with screen information in the format "width=W&height=H&scaling-factor=S&colour-depth=D,..."
 *
 */
export const getScreensInfo = (): string => {
	// Основной экран
	const mainScreen: ScreenInfo = {
		width: window.screen.width,
		height: window.screen.height,
		'scaling-factor': window.devicePixelRatio,
		'colour-depth': window.screen.colorDepth,
	};

	// Get information about all screens
	const screensInfo: ScreenInfo[] = [mainScreen];

	// if there are additional screens
	//  "width=W&height=H&scaling-factor=S&colour-depth=D,..."
	return screensInfo
		.map(
			(screen) =>
				`width=${screen.width}&height=${screen.height}&scaling-factor=${screen['scaling-factor']}&colour-depth=${screen['colour-depth']}`,
		)
		.join(',');
};

/**
 * get timezone
 * @returns {string} String with timezone in the format "UTC+HH:MM"
 */
export const getTimezone = (): string => {
	const offset: number = new Date().getTimezoneOffset();
	const hours: number = Math.abs(Math.floor(offset / 60));
	const minutes: number = Math.abs(offset % 60);

	const sign: string = offset <= 0 ? '+' : '-';
	const formattedHours: string = hours.toString().padStart(2, '0');
	const formattedMinutes: string = minutes.toString().padStart(2, '0');

	return `UTC${sign}${formattedHours}:${formattedMinutes}`;
};

/**
 * Get window size
 * @returns {string}  String with window size in the format "width=W&height=H"
 */
export const getWindowSize = (): string => {
	return `width=${window.innerWidth}&height=${window.innerHeight}`;
};

/**
 * Collect device information
 * @returns {DeviceInfo} Object with device information
 */
export const collectDeviceInfo = (): DeviceInfo => {
	return {
		'Gov-Client-Browser-JS-User-Agent': getUserAgent(),
		'Gov-Client-Screens': getScreensInfo(),
		'Gov-Client-Timezone': getTimezone(),
		'Gov-Client-Window-Size': getWindowSize(),
	};
};
